import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
 Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import UserManagementList from "./Componenets/UserManagement/UserManagementList";
import Sidebar from "./Sidebar/Sidebar";
import Dashboard from "./Componenets/Dashboard/Dashboard";
import Roles from "./Componenets/Roles/Roles";
import Reports from "./Componenets/Reports/Reports";
import Advertisement from "./Componenets/Ads/Ads";
import Settings from "./Componenets/Settings/Settings";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ProfileRegister from "./Componenets/Login/Login";
// import LoginPage from "./Componenets/Login/Login";
import RequestManagement from "./Componenets/RequestManagement/RequestManagement";
import Promotion from "./Componenets/Promotion/Promotion";
import RecycleBin from "./Componenets/RecycleBin/RecycleBin";
import Support from "./Componenets/Support/Support";
// import Login from "./Componenets/Login/Login";
import Offers from "./Componenets/Offers/Offers";
import Subscription from "./Componenets/Subscription/Subscription";
import Notification from "./Componenets/Notification/Notification";
// import ProductOwner from "./Componenets/Login/ProductOwner";
// import Employee from "./Componenets/Login/Employee";
// import Operator from "./Componenets/Login/Operator";
// import Partner from "./Componenets/Login/Partner";
import ProductOwnerLoginPage from "./Componenets/LoginPage/ProductOwner";
import OperatorLoginPage from "./Componenets/LoginPage/Operator";
import OwnerEmployeeLoginPage from "./Componenets/LoginPage/OwnerEmployee";
import PartnerLoginPage from "./Componenets/LoginPage/Partner";
import OperatorEmployeeLoginPage from "./Componenets/LoginPage/OperatorEmployee";
import BookingTable from "./Componenets/Dashboard/BookingTable";
// import dotenv from 'dotenv';
// dotenv.config();
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CancelTable from "./Componenets/Dashboard/CancelTable";
import Payments from "./Componenets/Payments/Payments";
import BackUp from "./Componenets/BackUp/BackUp";
import AccessDenied from "./Componenets/Common/AccessDenied";
import {PageNotFound} from "./Componenets/Common/404Error"
import WelcomePartner from "./Componenets/Common/WelcomePartner";
import PartnerDashboard from "./Componenets/Dashboard/Partner/PartnerDashboard";
import Loader from "./Componenets/Common/Loader";
import SuperAdminVault from "./Componenets/SuperAdminVault/SuperAdminVault";

function App() {
  // const [authtoken, setAuthtoken] = useState(sessionStorage.getItem("token"));
  const [authtoken, setAuthtoken] = useState(sessionStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  //  const navigate = useNavigate();
  // const location = useLocation();
  useEffect(() => {
    // const token = sessionStorage.getItem("token");
      const token = sessionStorage.getItem("token");
    if (token) {
      setAuthtoken(token);
    }
  }, []);
console.log(loading,"loading")

  // window.onbeforeunload = function () {
  //   localStorage.clear();
  // }
  console.log(authtoken, "authtoken852");
  const searchby = ["Operator name", "Phone", "Email"];
  const [currentSearch, setCurrentSearch] = useState(searchby[0]);

  useEffect(() => {
    // Function to reset localStorage when back navigation occurs
    const resetLocalStorageOnBack = () => {
      const historyState = window.history.state;
      // Check if it's the last page or any other condition for final back navigation
      if (historyState && historyState.idx === 0 && authtoken) {
        localStorage.clear(); // Reset the localStorage here
        sessionStorage.clear();
        setAuthtoken(null);
        window.location.reload();
        console.log("localStorage reset on last back navigation");
      } 
    };
    // Add event listener for popstate event
    window.addEventListener("popstate", resetLocalStorageOnBack);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("popstate", resetLocalStorageOnBack);
    };
  }, []);

  //--------------------------------handles logged in user manually entering / path
  // useEffect(() => {
  //   if (authtoken && window.location.pathname === '/') {
  //     sessionStorage.removeItem('token');
  //     setAuthtoken(null);
  //     window.location.reload();
  //   }
  // }, [authtoken]);

  // useEffect(() => {
  //   if (location.pathname === '/dashboard' && !authtoken) {
  //     navigate('/');
  //   }

  //   const handlePopState = () => {
  //     if (location.pathname === '/dashboard') {
  //       setAuthtoken(null);
  //       navigate('/');
  //     }
  //   };

  //   window.addEventListener('popstate', handlePopState);

  //   return () => {
  //     window.removeEventListener('popstate', handlePopState);
  //   };
  // }, [authtoken, location.pathname, navigate]);
  const storedModulePermissions = sessionStorage.getItem("module_permission");
  const currenttypeid = sessionStorage.getItem("type_id");
  console.log(currenttypeid,"currenttypeid")
  const modulePermissions = storedModulePermissions
    ? JSON.parse(storedModulePermissions)
    : [];
  const dashModules = [1, 2, 3];
  const showDashIcon = dashModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const razorPayModules = [4, 5, 6,33,34];
  const showRazorPayIcon = razorPayModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );

  const umModules = [7, 8, 9, 10, 11];
  const showUMIcon = umModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );

  const rmModules = [12, 13, 14, 15, 16];
  const showRMIcon = rmModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );

  const offersModules = [17, 18];
  const showOffersIcon = offersModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );

  const adsModules = [19, 20];
  const showAdsIcon = adsModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const promoModules = [21];
  const showPromotionsIcon = promoModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const rrModules = [22, 23];
  const showRRIcon = rrModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const subscribtionModules = [24];
  const showSubIcon = subscribtionModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const superAdminVaultModules = [35];
  const showSuperAdminvaultIcon = superAdminVaultModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const backUpModules = [25,26];
  const showBackUpIcon = backUpModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const settingModules = [27, 28, 29, 30, 31];
  const showSettingsIcon = settingModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const recycleModules = [32];
  const showRecycleIcon = recycleModules.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
console.log(authtoken,"auauauauaua")
  // if (loading) return <div>Loading...</div>; 
  return (
    <Router>
      <ToastContainer />
      {authtoken ? (
        <>
          <div className={`h-screen w-full pb-[6vw]`}>
            <Routes>
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}
              {(showDashIcon || currenttypeid === "PRO101")?(<Route path="/dashboard" element={<Dashboard setLoading={setLoading}/>} />): currenttypeid === "PROEMP101" ? (<Route path="/dashboard" element={<AccessDenied />} />) : currenttypeid === "PART101" && (<Route path="/dashboard" element={<PartnerDashboard/>}/>)
              }
              {/* <Route path="/payments" element={<Payments/>}/> */}
              {(showRazorPayIcon || currenttypeid === "PRO101")?(<Route path="/payments" element={<Payments />} />):(<Route path="/payments" element={<AccessDenied />} />)}
              {/* <Route path="/usermanagement" element={<UserManagementList />} /> */}
              {(showUMIcon || currenttypeid === "PRO101")?(<Route path="/usermanagement" element={<UserManagementList />} />):(<Route path="/usermanagement" element={<AccessDenied />} />)}
              {/* <Route path="/discounts" element={<Offers />} /> */}
              {(showOffersIcon || currenttypeid === "PRO101")?(<Route path="/discounts" element={<Offers />} />):(<Route path="/discounts" element={<AccessDenied />} />)}
              {/* <Route path="/ads" element={<Advertisement />} /> */}
              {(showAdsIcon || currenttypeid === "PRO101")?(<Route path="/ads" element={<Advertisement />} />):(<Route path="/ads" element={<AccessDenied />} />)}
              {/* <Route path="/settings" element={<Settings />} /> */}
              {(showSettingsIcon || currenttypeid === "PRO101")?(<Route path="/settings" element={<Settings />} />):(<Route path="/settings" element={<AccessDenied />} />)}
              {/* <Route path="/roles" element={<Roles />} /> */}
              {(showRRIcon || currenttypeid === "PRO101")?(<Route path="/roles" element={<Roles />} />):(<Route path="/roles" element={<AccessDenied />} />)}
              <Route path="/reports" element={<Reports />} />
              {/* <Route
                path="/requestmanagement"
                element={<RequestManagement />}
              /> */}
              {(showRMIcon || currenttypeid === "PRO101")?(<Route path="/requestmanagement" element={<RequestManagement />} />):(<Route path="/requestmanagement" element={<AccessDenied />} />)}
              {/* <Route path="/promotion" element={<Promotion />} /> */}
              {(showPromotionsIcon || currenttypeid === "PRO101")?(<Route path="/promotion" element={<Promotion />} />):(<Route path="/promotion" element={<AccessDenied />} />)}
              {/* <Route path="/recyclebin" element={<RecycleBin />} /> */}
              {(showRecycleIcon|| currenttypeid === "PRO101") ? (<Route path="/recyclebin" element={<RecycleBin />} />):(<Route path="/recyclebin" element={<AccessDenied />} />)}
              <Route path="/support" element={<Support />} />
              <Route path="/notification" element={<Notification />} />
              {/* <Route path="/subscription" element={<Subscription />} /> */}
              {(showSubIcon || currenttypeid === "PRO101") ? (<Route path="/subscription" element={<Subscription />} />) : (<Route path="/subscription" element={<AccessDenied/>} />)}
              {/* <Route path="/backup" element={<BackUp/>} /> */}
              {showSuperAdminvaultIcon || currenttypeid === "PRO101" ? (
  <Route path="/superadminvault" element={<SuperAdminVault />} />
) : (
  <Route path="/superadminvault" element={<AccessDenied />} />
)}
              {(showBackUpIcon || currenttypeid === "PRO101")?(<Route path="/backup" element={<BackUp />} />):(<Route path="/backup" element={<AccessDenied />} />)}
              {(currenttypeid === "PRO101")?(<Route path="/*"  element={<PageNotFound />} />):(<Route path="/*"  element={<PageNotFound />} />)}
            </Routes>
                      
          </div>
          <Sidebar setAuthtoken={setAuthtoken}/>
        </>
      ) : (
        <Routes>
          <Route
            path="/"
            element={<ProductOwnerLoginPage setAuthtoken={setAuthtoken} setLoading={setLoading}/>}
          />
          <Route
            path="/poemployee"
            element={<OwnerEmployeeLoginPage setAuthtoken={setAuthtoken} setLoading={setLoading}/>}
          />
          <Route
            path="/opemployee"
            element={<OperatorEmployeeLoginPage setAuthtoken={setAuthtoken} setLoading={setLoading}/>}
          />
          <Route path="/operator" element={<OperatorLoginPage setLoading={setLoading}/>} />
          <Route
            path="/partner"
            element={<PartnerLoginPage setAuthtoken={setAuthtoken} setLoading={setLoading}/>}
          />
          {loading ? <Route path="/dashboard" element={<Loader/>} /> : <Route path="/dashboard" element={<PageNotFound/>} /> }
          <Route path="/payments" element={<PageNotFound/>}/>
          <Route path="/usermanagement" element={<PageNotFound />} />
          <Route path="/requestmanagement" element={<PageNotFound />} />
          <Route path="/discounts" element={<PageNotFound />} />
          <Route path="/ads" element={<PageNotFound />} />
          <Route path="/promotion" element={<PageNotFound />} />
          <Route path="/roles" element={<PageNotFound />} />
          <Route path="/subscription" element={<PageNotFound />} />
          <Route path="/settings" element={<PageNotFound />} />
          <Route path="/recyclebin" element={<PageNotFound />} />
          <Route path="/backup" element={<PageNotFound/>} />
          <Route path="/*" element={<PageNotFound/>}/>
        </Routes>
      )}
    </Router>
  );
}

export default App;

// const WrappedApp = () => (
//   <Router>
//     <App />
//   </Router>
// );

// export default WrappedApp;
